if (typeof document === "undefined") return;
var extractCssCreateStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject, fetchPriority
) {
	var linkTag = document.createElement("link");
linkTag.setAttribute("data-vanilla-extract", "true");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;


if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
  linkTag.crossOrigin = 'anonymous';
}


	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var extractCssFindStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var extractCssLoadStylesheet = function (chunkId, fetchPriority) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (extractCssFindStylesheet(href, fullhref)) return resolve();
		extractCssCreateStylesheet(chunkId, fullhref, null, resolve, reject, fetchPriority);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	3808: 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises, fetchPriority) {
	var cssChunks = {
1129: 1,
1182: 1,
1333: 1,
1528: 1,
1542: 1,
164: 1,
1907: 1,
2263: 1,
2297: 1,
2355: 1,
2590: 1,
2683: 1,
2714: 1,
2807: 1,
2851: 1,
2853: 1,
2866: 1,
2867: 1,
2969: 1,
3024: 1,
3191: 1,
3482: 1,
3508: 1,
3604: 1,
3645: 1,
365: 1,
3662: 1,
3664: 1,
3825: 1,
3854: 1,
4121: 1,
4174: 1,
4440: 1,
4633: 1,
4706: 1,
4850: 1,
4873: 1,
4899: 1,
4960: 1,
5014: 1,
5024: 1,
5085: 1,
5117: 1,
5173: 1,
5301: 1,
5353: 1,
5698: 1,
5712: 1,
584: 1,
5902: 1,
6006: 1,
6014: 1,
605: 1,
6325: 1,
6386: 1,
673: 1,
6814: 1,
6829: 1,
6938: 1,
6942: 1,
7051: 1,
7059: 1,
7080: 1,
70: 1,
7140: 1,
7270: 1,
7367: 1,
7417: 1,
7438: 1,
7537: 1,
7601: 1,
7905: 1,
8029: 1,
8141: 1,
814: 1,
8197: 1,
8217: 1,
8460: 1,
8479: 1,
857: 1,
8742: 1,
8780: 1,
8985: 1,
9048: 1,
906: 1,
9071: 1,
9223: 1,
9297: 1,
9339: 1,
9488: 1,
9739: 1,
9800: 1,
9809: 1,
9866: 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = extractCssLoadStylesheet(chunkId, fetchPriority).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
// no prefetch
// no preload